import { render, staticRenderFns } from "./UploadFormDetail.vue?vue&type=template&id=1f6046d6&lang=true&"
import script from "./UploadFormDetail.vue?vue&type=script&lang=js&"
export * from "./UploadFormDetail.vue?vue&type=script&lang=js&"
import style0 from "./UploadFormDetail.vue?vue&type=style&index=0&id=1f6046d6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports